import { render, staticRenderFns } from "./FilterProducts.vue?vue&type=template&id=89a78736&scoped=true&"
import script from "./FilterProducts.vue?vue&type=script&lang=ts&"
export * from "./FilterProducts.vue?vue&type=script&lang=ts&"
import style0 from "./FilterProducts.vue?vue&type=style&index=0&id=89a78736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a78736",
  null
  
)

export default component.exports